import React from "react";
import styled from "styled-components";

import { MappingConfiguration } from "../../rule-engine-core/Mapping/MappingConfiguration";
import { XMappingSectionHeader } from "../Builder/CommonStyles";

import { ObserveState } from "../../CommonUI/StateManagement/ObserveState";

import { MappingEditContext } from "../Builder/MappingEditContext";

import { ValidationInformation } from "../../Rule/DesignUI/ValidationInformation";

export interface IMappingExpressions {
    definition: MappingConfiguration;
    editContext: MappingEditContext;
}

export const XMappingRules = (props: IMappingExpressions) => {
    const { definition } = props;

    return (
        <>
            <XMappingExpressionsRender>
                <XMappingSectionHeader>Expressions</XMappingSectionHeader>

                <ObserveState
                    listenTo={definition}
                    control={() => {
                        return <ValidationInformation provider={props.definition} />;
                    }}
                />
            </XMappingExpressionsRender>
        </>
    );
};

const XMappingExpressionsRender = styled.div`
    flex: 1;
    position: relative;
`;
